import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  PulseConfigurationKeys,
  PULSE_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/pulse-rules';
import {
  selectScanToBasketEnabled,
  selectScanToListEnabled,
} from '@epicuro-next/state/scan-state';
import { Store, select } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseNavigationComponent } from '../base-navigation.component';
import { NavigationService } from '../service/navigation.service';
import { selectBookmarkIcon } from '@epicuro-next/platform/configuration';

@Component({
  selector: 'epc-split-navigation',
  templateUrl: './split-navigation.component.html',
  styleUrls: ['./split-navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SplitNavigationComponent
  extends BaseNavigationComponent
  implements OnInit
{
  public bookmarkIcon$ = this.store.pipe(select(selectBookmarkIcon));

  public scannerEnabled$ = combineLatest([
    this.store.select(selectScanToListEnabled),
    this.store.select(selectScanToBasketEnabled),
  ]).pipe(
    map(
      ([scanToListEnabled, scanToBasketEnabled]) =>
        scanToListEnabled || scanToBasketEnabled,
    ),
  );

  public pulseNamespace = PULSE_FEATURE_NAME;
  public bannerEnabledFeatureKey = PulseConfigurationKeys.BannerEnabled;

  @ViewChild('topHeader') private elementView: ElementRef;

  constructor(store: Store, navigationService: NavigationService) {
    super(store, navigationService);
  }

  public ngOnInit() {
    this.initProductLists();
  }

  protected getTopHeaderHeight() {
    return this.elementView.nativeElement.offsetHeight;
  }
}
